<a class="mapfre link {{additionalClasses}}" mdbRipple>
  <span class="link-icon" *ngIf="icon">
    <i class="{{iconClasses}}"></i>
  </span>
  <span class="link-content"> 
    <ng-content></ng-content>
  </span>
</a>
  <!-- route={{url}} -->
